import { getSession } from 'next-auth/react'
import Layout from '@components/layout/layout-six'
import Seo from '@components/seo/seo'
import { useTranslation } from 'next-i18next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import QuickOrderPage from '@components/quick-order/quick-order-page'
import { ROUTES } from '@utils/routes'

export default function QuickOrder() {
  const { t: translate } = useTranslation('common')

  return (
    <>
      <Seo
        title="Quick Order"
        description={translate('text-home-seo-blurb', { ns: 'common' })}
        path="quick-order"
      />
      <div className="sm:w-[85%] md:w-[75%] lg:w-[65%] mx-auto px-2 py-10 md:px-6 lg:px-8 2xl:px-10 w-full">
        <QuickOrderPage />
      </div>
    </>
  )
}

QuickOrder.Layout = Layout

// Server-side props with authentication and localization
export const getServerSideProps = async ({ req, locale }) => {
  const session = await getSession({ req })
  if (session?.isGuest) {
    return {
      redirect: {
        destination: ROUTES?.SIGN_UP, // Redirects to signup if user is not logged in
        permanent: false,
      },
    }
  }

  return {
    props: {
      ...(await serverSideTranslations(locale!, [
        'common',
        'categories',
        'forms',
        'menu',
        'footer',
        'savelist',
        'quickorder',
        'cart',
      ])),
    },
  }
}
